import { BASEURL } from '../Constants';

const getToken = () => sessionStorage.getItem('token');

const unwrapList = (data, key) => {
  if (!data || typeof data !== 'object') return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data[key])) return data[key];
  if (Array.isArray(data.data)) return data.data;
  return [];
};

async function request(path, options = {}) {
  const response = await fetch(`${BASEURL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
      ...(options.headers || {}),
    },
  });

  if (response.status === 204) return null;

  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.error) {
    throw new Error(data?.message || 'Copilot remote request failed.');
  }
  return data;
}

export const copilotRemoteApi = {
  async listMachines() {
    const data = await request('/copilot/remote/machines');
    return unwrapList(data, 'machines');
  },

  async createMachine(payload) {
    const data = await request('/copilot/remote/machines', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data.machine || data;
  },

  async updateMachine(machineId, payload) {
    const data = await request(`/copilot/remote/machines/${encodeURIComponent(machineId)}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return data.machine || data;
  },

  async archiveMachine(machineId) {
    return request(`/copilot/remote/machines/${encodeURIComponent(machineId)}`, {
      method: 'DELETE',
    });
  },

  async getSessionMachine(sessionId) {
    const data = await request(`/copilot/sessions/${encodeURIComponent(sessionId)}/remote-machine`);
    return data.remote_machine || null;
  },

  async setSessionMachine(sessionId, payload) {
    const data = await request(`/copilot/sessions/${encodeURIComponent(sessionId)}/remote-machine`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data.remote_machine || data;
  },

  async clearSessionMachine(sessionId) {
    return request(`/copilot/sessions/${encodeURIComponent(sessionId)}/remote-machine`, {
      method: 'DELETE',
    });
  },

  async listSessionCommands(sessionId) {
    const data = await request(`/copilot/sessions/${encodeURIComponent(sessionId)}/remote-commands`);
    return unwrapList(data, 'commands');
  },

  async getCommand(commandId) {
    const data = await request(`/copilot/remote/commands/${encodeURIComponent(commandId)}`);
    return data.command || data.job || data;
  },

  async cancelCommand(commandId) {
    const data = await request(`/copilot/remote/commands/${encodeURIComponent(commandId)}/cancel`, {
      method: 'POST',
    });
    return data.command || data.job || data;
  },
};
